
import { createContext, useContext, useState, useEffect } from "react";
import { fetchUser } from "./ProfileContext"; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authloading, setAuthLoading] = useState(true);

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const userData = await fetchUser(); 
        setUser(userData);
      } catch (error) {
        setUser(null);
      } finally {
        setAuthLoading(false);
      }
    };
    checkLogin();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, authloading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

